/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospectsapproved2Inputs */

const en_coinvestments_prospectsapproved2 = /** @type {(inputs: Coinvestments_Prospectsapproved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospects Approved`)
};

/**
* | output |
* | --- |
* | "Prospects Approved" |
*
* @param {Coinvestments_Prospectsapproved2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospectsapproved2 = /** @type {((inputs?: Coinvestments_Prospectsapproved2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospectsapproved2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospectsapproved2(inputs)
});
export { coinvestments_prospectsapproved2 as "coInvestments_prospectsApproved" }